var map = {
	"./388359.jpg": 5138,
	"./DBLINK.png": 5527,
	"./GabrielTest.png": 8873,
	"./Hajer.PNG": 2304,
	"./Screenshot 2022-06-29 104144.png": 5508,
	"./kobby-mendez-d0oYF8hm4GI-unsplash.jpg": 2795,
	"./pexels-fauxels-3183199.jpg": 5910,
	"./wp4676581-4k-pc-wallpapers.jpg": 2656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4093;